import { createSlice } from "@reduxjs/toolkit";
import {
  getApiResponseErrorMessage,
  isUploadIssueResponse,
} from "../../common/apiResponse";
import { updateAiCampaignAPI } from "../../services/updateAiCampaign";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const updateAiCampaignSlice = createSlice({
  name: "updateAiCampaign",
  initialState: data,
  reducers: {
    updateAiCampaignInfo(state) {
      state.isLoading = true;
      state.error = "";
      state.message = "";
    },
    updateAiCampaignInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      const p = action.payload;
      state.message =
        typeof p?.message === "string" ? p.message : "Campaign updated successfully";
      state.error = "";
    },
    updateAiCampaignInfoFailure(state, action) {
      state.isLoading = false;
      const payload = action.payload;

      if (isUploadIssueResponse(payload)) {
        state.data = payload;
        state.message = "";
        state.error = getApiResponseErrorMessage(payload) || "";
        return;
      }

      state.message = "";
      state.error =
        typeof payload === "string"
          ? payload
          : payload?.message != null
            ? String(payload.message)
            : Array.isArray(payload?.errors)
              ? payload.errors.map(String).join(" ")
              : payload != null
                ? String(payload)
                : "Something went wrong";
      state.data = null;
    },
    updateAiCampaignInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const updateAiCampaignHandler = (payload) => async (dispatch) => {
  try {
    dispatch(updateAiCampaignAction.updateAiCampaignInfo());
    const response = await updateAiCampaignAPI(payload);
    dispatch(updateAiCampaignAction.updateAiCampaignInfoSuccess(response));
  } catch (e) {
    dispatch(updateAiCampaignAction.updateAiCampaignInfoFailure(e));
  }
};

export default updateAiCampaignSlice.reducer;
export const updateAiCampaignAction = updateAiCampaignSlice.actions;
